import { Component, HostBinding, Input } from '@angular/core'

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false,
})
export class ButtonComponent {
  @Input()
  public disabled?: boolean

  @Input()
  public type?: string

  @Input()
  public label?: string

  @Input()
  public fullWidth?: boolean = true

  @Input()
  public link?: boolean

  @Input()
  public image?: string

  @Input()
  public color?: string

  @Input()
  public text?: string

  @Input()
  public routerLink?: string

  @Input()
  public border?: string

  /**
   * Display the image above the text rather than inline
   */
  @Input()
  public stacked = false

  @Input()
  public size?: 'small' | 'medium' | 'large'

  @HostBinding('style.--bg-color')
  get bgColor(): string {
    if (this.color) return `var(--color-${this.color})`
    return ''
  }

  @HostBinding('style.--txt-color')
  get txtColor(): string {
    if (this.text) return `var(--color-${this.text})`
    return ''
  }

  @HostBinding('style.--border-color')
  get brdrColor(): string {
    if (this.border) return `var(--color-${this.border})`
    return ''
  }
}
